import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import starImage from "../../../assets/images/icon/starImg.svg";
import IMG_AVATAR from "../../../assets/images/img_avatar.png";
import {
  Directions,
  sportConstantsReversed,
  translationConstants,
} from "../../../constants";
import { sportNames } from "../../../modules/AdminPortal/Views/Spots/utilities";
import DeleteModal from "../Modals/DeleteModal";
import CustomModal from "../CustomModal/CustomModal";
import {
  centerInstructorsActions,
  centerListingActions,
} from "../../../redux/actions";

const InstructorCard = ({
  instructor,
  setInstructorData,
  setIsViewDetail,
  isShowRemoveButton,
  centerId,
  gridState,
}) => {
  const { t } = useTranslation();
  const [showDelete, setShowDelete] = useState(false);
  const dispatch = useDispatch();

  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });

  const getSportName = (sportId) => {
    const sportName = sportNames[sportId];
    return sportName;
  };

  const handleViewDetailClick = () => {
    setInstructorData(instructor);
    setIsViewDetail(true);
  };

  const removeRowData = (data) => {
    dispatch(
      centerInstructorsActions.removeCenterInstructorByAdmin(
        centerId,
        data?.instructorId,
        () => {
          setShowDelete(false);
          dispatch(
            centerListingActions.getAllCenterInstructors(gridState, centerId)
          );
        }
      )
    );
  };

  return (
    <>
      <div className="col-sm-6 col-lg-4 custom-card-wrapper p-2">
        <div
          className="card custom-card h-100  cast-shadow-on-hover"
          onClick={() => handleViewDetailClick()}
        >
          <div className="card-body d-flex gap-3">
            <div className="profile-img rounded-circle d-flex align-items-center">
              <img
                src={
                  instructor?.profilePicture?.link
                    ? instructor?.profilePicture?.link
                    : IMG_AVATAR
                }
                alt=""
                className="rounded-circle"
                height={70}
                width={70}
              />
            </div>
            <div className="info mx-2 w-100">
              <div className="row">
                <div className="d-flex justify-content-between w-100 align-items-center">
                  <p className="card-title fw-bolder text-truncate text-truncate-charactor-limit-instructor-card">
                    {direction === Directions.rtl &&
                    instructor.arabicFirstName &&
                    instructor.arabicLastName
                      ? `${instructor.arabicFirstName} ${instructor.arabicLastName}`
                      : `${instructor.englishFirstName} ${instructor.englishLastName}`}
                  </p>

                  <div className="rating d-flex gap-1">
                    <span> {`${instructor?.rating.toFixed(1)}/5`}</span>
                    <img
                      src={starImage}
                      alt="Star Icon"
                      className="star-icon"
                    />
                  </div>
                </div>

                <div className="details instructor-level-details">
                  {instructor?.sportIds.map((level, index) => (
                    <div key={index} className="text-color-theme small">
                      {t(translationConstants[sportConstantsReversed[level]])}
                    </div>
                  ))}
                </div>

                <div className="extra mt-auto">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="card-text">
                      <small className="fw-600">
                        {`${instructor?.noOfStudents} ${t(
                          translationConstants.STUDENTS
                        )}`}
                      </small>
                    </p>
                    {/*eslint-disable-next-line */}
                    <div>
                      <a
                        className="link text-underline small text-color-theme cursor-pointer view-intructor-detail-link"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleViewDetailClick();
                        }}
                      >
                        {t(translationConstants.VIEW_DETAILS)}
                      </a>
                      {isShowRemoveButton && (
                        <p
                          className="link text-underline small text-color-danger cursor-pointer view-intructor-detail-link"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowDelete(true);
                          }}
                        >
                          {t(translationConstants.REMOVE)}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showDelete && (
          <CustomModal
            scrollable={true}
            size="md"
            setShow={setShowDelete}
            show={showDelete}
            customClass="view-user-modal"
          >
            <DeleteModal
              title={t(translationConstants.REMOVE_INSTRUCTOR)}
              message={`${t(translationConstants.ARE_YOU_SURE_TO_REMOVE)} ${
                instructor?.name
              }`}
              dataToDelete={instructor}
              removeRowData={removeRowData}
              onCancel={() => setShowDelete(false)}
            />
          </CustomModal>
        )}
      </div>
    </>
  );
};

export default InstructorCard;
